import config from './config/create'
import axios from '@/utils/request'

export const addorg = params => axios.post(config.addorg, params) // 创建学院
export const uploadimage = params => axios.post(config.uploadimage, params) // 上传图片
export const myorg = params => axios.post(config.myorg, params) // 我的学院
export const addtenant = params => axios.post(config.addtenant, params) // 我的学院
